<style lang="scss" >
    .user-guidance {
        .el-dialog__header{
            display: none;
            padding: 0!important;
        }
        .el-dialog__body{
            padding: 0px!important;
        }
        .cricle-guid{
            width:12px;
            height: 12px;
            background:#737373 ;
            border-radius: 50%;
            margin-left: 10px;
            cursor: pointer;
        }
        .cur-guid{
            background: #4B75FF!important;;
        }
    }
    .anmimate-box{
        // position: absolute;
        // top: 0px;
        // bottom: 0px;
        width: 100%;
        overflow-x: hidden!important;;
    }
    .slide-right-enter-active,
    .slide-right-leave-active,
    .slide-left-enter-active,
    .slide-left-leave-active {
        will-change: transform;
        transition: all 500ms;
        position: absolute;
    }
    .slide-right-enter {
        opacity: 0;
        transform: translate3d(-100%, 0, 0);
    }
    .slide-right-leave-active {
        opacity: 0;
        transform: translate3d(100%, 0, 0);
    }
    .slide-left-enter {
        opacity: 0;
        transform: translate3d(100%, 0, 0);
    }
    .slide-left-leave-active {
        opacity: 0;
        transform: translate3d(-100%, 0, 0);
    }
</style>
<style lang="scss" scoped>
    .btn{
        width: 140px;
        cursor: pointer;
        border-radius: 4px;
        font-size: 20px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        line-height: 50px;
        text-align: center;
    }
    .blue{
        border: 2px solid #4B75FF;
        color: #4B75FF;
    }
    .white{
        border: 2px solid #979797;
        color:#ffffff ;
    }
    .theme_icon{
        width:240px;
        height:130px;
        cursor: pointer;
    }
</style>
<template>
    <el-dialog
        :title="$t('使用指南')"
        :visible.sync="showGuidance"
        :show-close="false"
        width="860px"
        class="user-guidance"
        center>
        <div v-if="currentPage == 0">
            <img src="/static/imgs/guid/bg1.png" style="width:100%;height:auto;text-align:center;display:block">
            <img  @click="currentPage+=1" src="/static/imgs/guid/first_icon.png" class="c_pointer" style="width: 65px;height: 65px;position: absolute;left: 46%;z-index: 999;bottom: 85px;">
        </div>
        <div v-else style="height:480px;position:relative;background:#001326;overflow-x: hidden;overflow-y:hidden;">
            <div class="anmimate-box" style="width:100%;height:410px;overflow-y:auto;">
                <transition-group name="slide-left" tag="ul" style="line-height: 0;">
                    <div v-show="currentPage==(index+1)" v-for="(item,index) in pageList" :key="index" style="width:100%;">
                        <img :src="item.url" style="width:100%;height:auto;text-align:center;display:block">
                        <div v-if="currentPage == 1" style="width:100%;text-align:center;position:absolute;top:170px">
                            <div class="fl" style="margin-left:50px;">
                                <img src="/static/imgs/guid/second_icon1.png" class="theme_icon ">
                                <div class="mt20">
                                    <el-checkbox v-model="light" @change="dark=false;gold=false;changeTheme(light,'light-theme')">{{$t('中交蓝')}}</el-checkbox>
                                </div>
                            </div>
                            <div class="fl">
                                <img src="/static/imgs/guid/second_icon2.png" class="ml20 theme_icon">
                                <div class="mt20">
                                    <el-checkbox   v-model="dark" @change="light=false;gold=false;changeTheme(dark,'dark-theme')">{{$t('繁星黑')}}</el-checkbox>
                                </div>
                            </div>
                            <div class="fl">
                                <img src="/static/imgs/guid/second_icon3.png" class="ml20 theme_icon">
                                <div class="mt20">
                                    <el-checkbox  v-model="gold" @change="light=false;dark=false;changeTheme(gold,'gold-theme')">{{$t('奢雅金')}}</el-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition-group>
            </div>
            <div style="width:100%;display: inline-block;position:absolute;height: 70px;">
                <ul class="fl ml40 mt30">
                    <li class="cricle-guid fl" :class="{'cur-guid':index+1==currentPage}" @click="currentPage=index+1" v-for="(item,index) in pageList.length-1" :key="index"></li>
                </ul>
                <div class="btn blue mr40 fr" v-if="currentPage!=pageList.length-1" @click="currentPage==pageList.length-1?(currentPage=1):currentPage+=1">{{$t('继续了解')}}</div>
                <div class="btn white mr20 fr" @click="showGuidance=false;setGuidFlag()" >{{$t('立即体验')}}</div>
            </div> 
        </div>
    </el-dialog>
</template>
<script>
import {setGuidance,getGuidance} from '@/utils/auth.js'
import { mapGetters } from 'vuex'
export default {
    data(){
        return {
            showGuidance:true,
            currentPage:0,
            light:false,
            dark:false,
            gold:false,
            pageList:[
                {url:'/static/imgs/guid/bg2.png'},
                {url:'/static/imgs/guid/bg3.png'},
                {url:'/static/imgs/guid/bg4.png'},
                {url:'/static/imgs/guid/bg5.png'},
                {url:'/static/imgs/guid/bg6.png'},
                {url:'/static/imgs/guid/bg7.png'}
            ]
        }
    },
     computed: {
        ...mapGetters([
            'userInfo'
        ])
    },
    created(){
        this.showGuidance = getGuidance(this.userInfo.id)
    },
    methods:{
        changeTheme(flag,theme){
            if(flag){
                this.$emit("cancelOperate",theme)
            }else{
                this.$emit("cancelOperate",'light-theme')
            }
        },
        setGuidFlag(){
            setGuidance(this.userInfo.id,false)
        },
    }
}
</script>